// extracted by css-extract-rspack-plugin
export default {"adornment":"EndAdornment_adornment__nt9Jm"};